module.exports = __webpack_public_path__ + "static/img/amp-bass.b41b1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp-bass.png
// module id = 0V8m
// module chunks = 13